/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PackagingType } from '../../models/packaging-type';

export interface PackagingControllerFindById$Params {
  id: string;
}

export function packagingControllerFindById(http: HttpClient, rootUrl: string, params: PackagingControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<PackagingType>> {
  const rb = new RequestBuilder(rootUrl, packagingControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PackagingType>;
    })
  );
}

packagingControllerFindById.PATH = '/packaging-types/{id}';
